<template>
    <div id="notification-content" v-if="visible">
        <div
            v-for="notification in notifications"
            :key="notification.timestamp"
            :class="notificationClasses(notification)"
            class="alert alert-dismissible fade show text-white mb-0"
            role="alert"
            v-click-outside="onClickOutside"
        >
            <span v-html="notification.message" />
            <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
                @click="removeNotification(notification)"
            >
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>

<script>
import { LUDUM_MESSAGE_TYPE } from '@/constants';
import vClickOutside from 'v-click-outside';

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    computed: {
        visible() {
            return this.notifications.some(notification => Boolean(notification.message));
        },
        notifications() {
            return this.$store.state.globalNotifications.notifications;
        }
    },
    methods: {
        /**
         * Remove notification from display before timeout finishes
         *
         * @param {Object} notification
         * @return {Promise}
         */
        removeNotification(notification) {
            return this.$store.dispatch('removeNotification', notification);
        },
        notificationClasses(notification) {
            const { SUCCESS, INFO, WARNING, ERROR } = LUDUM_MESSAGE_TYPE;

            const classSuffixes = {
                [SUCCESS]: 'success',
                [INFO]: 'primary',
                [WARNING]: 'warning',
                [ERROR]: 'danger'
            };
            return `alert-${classSuffixes[notification.type]}`;
        },
        onClickOutside() {
            this.notifications.forEach(notification => {
                this.removeNotification(notification);
            });
        }
    }
};
</script>
